import { BodyProps, Box, Container, Link, Stack } from '@hover/blueprint';
import React from 'react';
import { ArrowButton } from '@hover/shared-components';
import { HeaderDescription } from '..';
import { URLS } from '../../../constants';

export interface IBeTheFirstToKnowProps {
  body: string;
  bodyProps?: BodyProps;
}

const BeTheFirstToKnow: React.FC<IBeTheFirstToKnowProps> = ({
  body,
  bodyProps,
}) => (
  <Box w="100%" bg="brandNavy.500" py={1000}>
    <Container maxW="3xl" px={{ base: 500, tablet: 0 }} centerContent>
      <HeaderDescription
        px={0}
        heading="Be the first to know"
        body={body}
        headingProps={{
          color: 'neutral.0',
          style: { marginBottom: 24, fontWeight: 700 },
        }}
        bodyProps={{
          color: 'neutral.0',
          style: { marginBottom: 40 },
          maxW: { base: '100%', tablet: '80%' },
          ...bodyProps,
        }}
      />

      <Stack
        w={{ base: '100%', tablet: 'auto' }}
        direction={{ base: 'column', tablet: 'row' }}
        spacing={{ base: 400, tablet: 500 }}
      >
        <ArrowButton
          as={Link}
          href={URLS.interiors.getEarlyAccess}
          colorScheme="brandNavy"
          variant="inverted"
          w={{ base: '100%', tablet: 'auto' }}
        >
          REQUEST ACCESS
        </ArrowButton>
      </Stack>
    </Container>
  </Box>
);

export default BeTheFirstToKnow;
